export default function Concept() {
  return (
    <section id="concept" className="py-20 px-4 sm:px-6 lg:px-8 bg-pink-50/50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-8 leading-relaxed">
          「稼げる」だけじゃない。<br className="hidden sm:block" />
          長く安心して働ける環境がここにあります。
        </h2>
        <div className="text-gray-700 text-lg leading-loose space-y-6 text-justify sm:text-center">
          <p>
            メンズエステ咲くら庵は、大阪難波・日本橋エリアにある健全なリラクゼーションサロンです。<br className="hidden sm:block" />
            風俗店のようなサービスは一切ありません。
          </p>
          <p>
            千日前通りのビル4階フロア全体となっており、エレベータのフロア開閉も管理可能、プライバシーと安全面も万全。<br className="hidden sm:block" />
            Web専属マネージャーによる強力な集客力と、業界最高水準の待遇で、あなたをお迎えします。
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 text-left max-w-2xl mx-auto">
          <div className="flex flex-col gap-4">
            <div className="flex items-start gap-3">
              <i className="ri-map-pin-line text-pink-500 text-xl mt-1"></i>
              <div>
                <p className="font-bold text-gray-800">住所</p>
                <p className="text-gray-600">〒542-0074 大阪府大阪市中央区千日前１丁目９−１２ 4階</p>
                <a href="https://share.google/OELCFkaWPVei1iCA4" target="_blank" rel="noopener noreferrer" className="text-pink-500 text-sm font-bold hover:underline inline-flex items-center gap-1 mt-1">
                  Google Mapsで見る <i className="ri-external-link-line"></i>
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-phone-line text-pink-500 text-xl mt-1"></i>
              <div>
                <p className="font-bold text-gray-800">電話番号</p>
                <a href="tel:0662118873" className="text-gray-600 hover:text-pink-500 transition-colors">06-6211-8873</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
